import logoImage from 'common/assets/image/app/logo.png';
import Box from 'common/components/Box';
import Drawer from 'common/components/Drawer';
import HamburgMenu from 'common/components/HamburgMenu';
import NavbarWrapper from 'common/components/Navbar';
import RegularMenu from 'common/components/RegularMenu';
import Container from 'common/components/UI/Container';
import Logo from 'common/components/UIElements/Logo';
import { DrawerContext } from 'common/contexts/DrawerContext';
import { graphql, Link, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

const Navbar = ({ navbarStyle, logoStyle, button, row, menuWrapper }) => {
  const { state, dispatch } = useContext(DrawerContext);

  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: 'TOGGLE',
    });
  };

  const data = useStaticQuery(graphql`
    query {
      appJson {
        menu_items {
          label
          path
          offset
        }
      }
    }
  `);

  const { appJson : menu_items } = data;

  return (
    <NavbarWrapper {...navbarStyle}>
      <Container width="1400px">
        <Box {...row}>
          <Logo
            href="/"
            logoSrc={logoImage}
            title="Furbuz"
            logoStyle={logoStyle}
            className="main-logo"
          />
          <Box {...menuWrapper} className="mainMenuWrapper">
            <RegularMenu
              className="main_menu"
              menuItems={menu_items?.menu_items}
            />
            <Link
              to="https://play.google.com/store/apps/details?id=com.acmeways.furbuz"
              className="navbar_download"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Furbuz
            </Link>
            <Drawer
              width="420px"
              placement="right"
              drawerHandler={<HamburgMenu barColor="#1A1A1A" />}
              open={state.isOpen}
              toggleHandler={toggleHandler}
            >
              <RegularMenu
                className="mobile_menu"
                menuItems={menu_items?.menu_items}
                drawerClose={true}
              />
              <Link
                to="https://play.google.com/store/apps/details?id=com.acmeways.furbuz"
                className="mobile_download"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Furbuz
              </Link>
            </Drawer>
          </Box>
        </Box>
      </Container>
    </NavbarWrapper>
  );
};

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  button: PropTypes.object,
  row: PropTypes.object,
  menuWrapper: PropTypes.object,
};

Navbar.defaultProps = {
  navbarStyle: {
    className: 'app_creative_two_navbar',
    minHeight: '70px',
    display: 'block',
  },
  row: {
    flexBox: true,
    alignItems: 'center',
    width: '100%',
  },
  logoStyle: {
    maxWidth: ['168px', '188px'],
    display: 'block',
  },
  button: {},
  menuWrapper: {
    flexBox: true,
    alignItems: 'center',
  },
};

export default Navbar;
